/**
 * laylo-reveal.js
 * Intersection Observer powered fade-up reveal for the Laylo theme.
 *
 * ─── Usage ───────────────────────────────────────────────────────────────────
 *
 *  Class-based (simple elements):
 *    <div class="reveal-item"> … </div>
 *
 *  Attribute-based (individual element):
 *    <div data-laylo-reveal> … </div>
 *
 *  Explicit stagger delay (1–5, each step = 120 ms):
 *    <div data-laylo-reveal data-laylo-delay="2"> … </div>
 *
 *  Auto-stagger group (children with data-laylo-reveal fire in DOM order,
 *  160 ms apart, when the GROUP container enters the viewport):
 *    <ul data-laylo-reveal-group>
 *      <li data-laylo-reveal> … </li>
 *      <li data-laylo-reveal> … </li>
 *    </ul>
 *
 * ─── Notes ───────────────────────────────────────────────────────────────────
 *  • Both systems add .is-visible when the element enters the viewport.
 *  • Exits early when prefers-reduced-motion is set (elements stay visible).
 *  • Each element is unobserved after reveal — zero ongoing cost.
 *  • CSS counterpart: laylo-global.css (.reveal-item, [data-laylo-reveal]).
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Helpers ─────────────────────────────────────────────────────────────── */

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function revealGroup(group) {
    var children = Array.from(group.querySelectorAll('[data-laylo-reveal]'));
    children.forEach(function (child, i) {
      var explicitDelay = child.dataset.layloDelay;
      var ms = explicitDelay ? parseInt(explicitDelay, 10) * 120 : i * 160;
      setTimeout(function () { reveal(child); }, ms);
    });
  }

  /* ── .reveal-item observer (threshold: 0.1) ──────────────────────────────── */

  var revealItems = document.querySelectorAll('.reveal-item');

  if (revealItems.length) {
    var itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        itemObserver.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    revealItems.forEach(function (el) { itemObserver.observe(el); });
  }

  /* ── [data-laylo-reveal] observer ────────────────────────────────────────── */

  var revealEls = document.querySelectorAll('[data-laylo-reveal]');

  if (revealEls.length) {
    var elementObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        elementObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -60px 0px'
    });

    revealEls.forEach(function (el) {
      if (!el.closest('[data-laylo-reveal-group]')) {
        elementObserver.observe(el);
      }
    });
  }

  /* ── [data-laylo-reveal-group] observer ──────────────────────────────────── */

  var groups = document.querySelectorAll('[data-laylo-reveal-group]');

  if (groups.length) {
    var groupObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealGroup(entry.target);
        groupObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    groups.forEach(function (group) { groupObserver.observe(group); });
  }

})();
